'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ticketDeplacerPopinController", function ($scope, $http, $q, lovService, $notifications) {
  var ticket = $scope.ticket;
  $scope.params = {
    ticketId: $scope.ticket.id,
    compteCibleId: $scope.ticket.compteId
  };
  $http.get('/rest/echange/comptes-cible-deplacement-ticket/' + $scope.params.ticketId).then(function (response) {
    $scope.comptesAccessibles = response.data;
  });
  $scope.deplacer = function () {
    $http.post('/rest/echange/ticket-deplacer/' + $scope.params.ticketId + "/" + $scope.params.compteCibleId).then(function () {
      $notifications.info("Changement de compte effectué");
      $scope.$close();
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/editionConsultant/ticketDeplacerPopinController.js
// module id = 2891
// module chunks = 13